import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { FORM_SEMESTER_LABEL } from '../../constants/translationLabels/formElements';
import { RHFAutocomplete } from '../../share/rhf';
import { getAllPublicGroupsStart } from '../../actions/groups';

// Loading the default semester's groups belongs to SchedulePageForm, not here: this picker is
// shown to managers only, and the group filter beside it needs its options whoever is looking.
const SemestersList = ({ control, setValue }) => {
    const { t } = useTranslation('common');
    const dispatch = useDispatch();

    const semesters = useSelector((state) => state.schedule.semesters);

    if (semesters && semesters.length > 1) {
        return (
            <RHFAutocomplete
                control={control}
                name="semester"
                options={semesters}
                label={t(FORM_SEMESTER_LABEL)}
                getOptionLabel={(semester) => (semester ? semester.description : '')}
                className="schedule-form_semester"
                onAfterChange={(value) => {
                    if (value) {
                        dispatch(getAllPublicGroupsStart(value.id));
                        setValue('group', null);
                        setValue('teacher', null);
                        setValue('department', null);
                    }
                }}
            />
        );
    }
    if (semesters && semesters.length === 1) {
        return <p className="schedule-form_semester">{semesters[0].description}</p>;
    }
    return null;
};

export default SemestersList;
